// extracted by mini-css-extract-plugin
export default {"legal":"components-Cart-LegalStatement-styles-module__legal--Rs_gU"};